const storeCurrency = () => process.env.GATSBY_CURRENCY === "EUR" ? "€" : "£";

export default storeCurrency;